/* White Noise The Label: The Frequency Look, page behaviour (Heidi, 2026-10-14).
   Ported from the approved homepage example v86. No libraries. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;

  /* Icon bar: white over the film, solid white once you scroll past it */
  var hd = document.getElementById('wnf-bar');
  var hero = document.querySelector('[data-wnf-hero]');
  function onScroll() {
    if (!hd) return;
    var limit = hero ? hero.offsetHeight - 60 : -1;
    hd.classList.toggle('solid', window.scrollY > limit);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', onScroll);
  onScroll();

  /* Phone menu */
  var mb = document.querySelector('[data-wnf-menu]'), dr = document.getElementById('wnf-drawer');
  if (mb && dr) {
    mb.addEventListener('click', function () { dr.hidden = false; mb.setAttribute('aria-expanded', 'true'); var c = dr.querySelector('.close'); if (c) c.focus(); });
    dr.querySelector('.close').addEventListener('click', function () { dr.hidden = true; mb.setAttribute('aria-expanded', 'false'); mb.focus(); });
  }

/* Set panel (go-live 14 Oct): Set opens Women · Men · The Lineup · The Set. Click or tap toggles it; on a mouse it
   also opens on hover. While it is open the bar is solid white. Escape, a click elsewhere or leaving the bar closes it. */
var sb = hd && hd.querySelector('[data-wnf-set]'), sp = document.getElementById('wnf-setpanel'), st;
function setOpen(on) { if (!sb || !sp) return; clearTimeout(st); sp.hidden = !on; sb.setAttribute('aria-expanded', on ? 'true' : 'false'); hd.classList.toggle('is-open', on); }
if (sb && sp) {
  sb.addEventListener('click', function () { setOpen(sp.hidden); });
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    sb.addEventListener('mouseenter', function () { setOpen(true); });
    hd.addEventListener('mouseenter', function () { clearTimeout(st); });
    hd.addEventListener('mouseleave', function () { st = setTimeout(function () { setOpen(false); }, 220); });
  }
  document.addEventListener('click', function (e) { if (!sp.hidden && !hd.contains(e.target)) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sp.hidden) { setOpen(false); sb.focus(); } });
  hd.addEventListener('focusout', function (e) { if (e.relatedTarget && !hd.contains(e.relatedTarget)) setOpen(false); });
}

  /* Fade-up on scroll for statement text */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.3 });
    document.querySelectorAll('.wnf .fade').forEach(function (e) { io.observe(e); });
  } else {
    document.querySelectorAll('.wnf .fade').forEach(function (e) { e.classList.add('in'); });
  }

  /* Full-screen film with sound (shared by the hero's Watch the film and the film block's button) */
  function fullscreen(v, onDone) {
    v.hidden = false; v.currentTime = 0; v.muted = false;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    if (v.requestFullscreen) { v.requestFullscreen().catch(function () {}); }
    else if (v.webkitEnterFullscreen) { v.webkitEnterFullscreen(); }
    function done() { if (onDone) onDone(); }
    document.addEventListener('fullscreenchange', function h() { if (!document.fullscreenElement) { document.removeEventListener('fullscreenchange', h); done(); } });
    v.addEventListener('webkitendfullscreen', done, { once: true });
    v.addEventListener('ended', function () { if (document.exitFullscreen && document.fullscreenElement) document.exitFullscreen(); done(); }, { once: true });
  }

  /* Safari and Low Power Mode can refuse to start a film on their own: try at once, and if refused,
     start it on the visitor's first touch, click, key or scroll (Tugba, 14 Oct: every film must play). */
  var GEST = ['pointerdown', 'touchstart', 'click', 'keydown', 'scroll', 'wheel'];
  function armGesture(v) {
    var go = function () { GEST.forEach(function (e) { document.removeEventListener(e, go, true); }); var q = v.play(); if (q && q.catch) q.catch(function () {}); };
    GEST.forEach(function (e) { document.addEventListener(e, go, { capture: true, passive: true }); });
  }
  function kick(v) {
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.playsInline = true;
    var p = v.play(); if (p && p.catch) p.catch(function () { armGesture(v); });
  }

  /* Banner films loop for every visitor, Reduce Motion included (Tugba, 14 Oct); Pause stays available. */
  /* Hero: the poster paints first; the loop is attached after the page loads (phones get the light cut) */
  if (hero) {
    var lv = hero.querySelector('video.loop');
    if (lv) {
      var src = phone ? (lv.getAttribute('data-m') || lv.getAttribute('data-d')) : lv.getAttribute('data-d');
      var start = function () {
        if (!src) return;
        lv.addEventListener('playing', function () { hero.classList.add('is-playing'); }, { once: true });
        lv.src = src;
        kick(lv);
      };
      if (document.readyState !== 'loading') setTimeout(start, 0); else document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
    }
    var hp = hero.querySelector('[data-wnf-hpause]');
    if (hp && lv) {
      hp.addEventListener('click', function () {
        if (lv.paused) { var p = lv.play(); if (p && p.catch) p.catch(function () {}); hp.textContent = hp.getAttribute('data-pause'); }
        else { lv.pause(); hp.textContent = hp.getAttribute('data-play'); }
      });
    }
    var hw = hero.querySelector('[data-wnf-watch]'), ff = hero.querySelector('video.fullfilm');
    if (hw && ff) {
      hw.addEventListener('click', function () {
        if (!ff.src) ff.src = ff.getAttribute('data-src');
        fullscreen(ff, function () { ff.pause(); ff.hidden = true; });
      });
    }
  }

  /* The Sound of the Frequency: starts when it scrolls into view; Watch the film, Sound on, Pause */
  document.querySelectorAll('[data-wnf-film]').forEach(function (s) {
    var v = s.querySelector('video'); if (!v) return;
    var snd = s.querySelector('[data-snd]'), pp = s.querySelector('[data-pp]'), w = s.querySelector('[data-watch]');
    function load() { if (!v.src) { v.src = v.getAttribute('data-src'); } }
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (s.getAttribute('data-user-paused')) return; load(); v.setAttribute('playsinline', ''); v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; armGesture(v); }); }
          else if (!v.paused && !document.fullscreenElement) { v.pause(); }
        });
      }, { threshold: 0.25 });
      o.observe(s);
    }
    if (snd) snd.addEventListener('click', function () { load(); v.muted = !v.muted; if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } snd.textContent = v.muted ? snd.getAttribute('data-on') : snd.getAttribute('data-off'); });
    if (pp) pp.addEventListener('click', function () { load(); if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); s.removeAttribute('data-user-paused'); pp.textContent = pp.getAttribute('data-pause'); } else { v.pause(); s.setAttribute('data-user-paused', '1'); pp.textContent = pp.getAttribute('data-play'); } });
    if (w) w.addEventListener('click', function () { load(); fullscreen(v, function () { v.muted = true; if (snd) snd.textContent = snd.getAttribute('data-on'); }); if (snd) snd.textContent = snd.getAttribute('data-off'); });
  });

  /* Lineup rail arrows */
  document.querySelectorAll('[data-wnf-rail]').forEach(function (sec) {
    var r = sec.querySelector('.rail');
    sec.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () { r.scrollBy({ left: Number(b.getAttribute('data-dir')) * r.clientWidth * 0.75, behavior: reduce ? 'auto' : 'smooth' }); });
    });
  });

  /* Add to bag: live variant, Shopify cart; the bar's count updates. Go-live 14 Oct: a short "Added to your bag"
     shows beside the button (its own polite live region, so screen readers hear it once), then fades. */
  var live = document.getElementById('wnf-live');
  function note(b, ok) {
    var sc = b.closest ? b.closest('[data-wnf-scope]') : null, n = sc && sc.querySelector('[data-wnf-added]');
    if (!n) { if (live) live.textContent = ok ? (b.getAttribute('data-name') || 'Item') + ' added to your bag.' : 'Sorry, that could not be added. Please try again.'; return; }
    clearTimeout(n._t); n.classList.toggle('is-err', !ok);
    if (ok && n.getAttribute('data-bag')) { n.innerHTML = ''; n.appendChild(document.createTextNode('Added to your bag \u00b7 ')); var a = document.createElement('a'); a.href = n.getAttribute('data-bag'); a.textContent = 'View bag'; n.appendChild(a); }
    else { n.textContent = ok ? 'Added to your bag' : 'Sorry, please try again'; }
    n.classList.add('is-on'); n._t = setTimeout(function () { n.classList.remove('is-on'); n._t = setTimeout(function () { n.textContent = ''; }, 400); }, ok ? 4000 : 5000);
  }
  function setCount(n) { document.querySelectorAll('[data-wnf-count],[data-wnfc-count]').forEach(function (e) { e.textContent = n; }); }
  document.querySelectorAll('[data-wnf-add]').forEach(function (b) {
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      var id = b.getAttribute('data-wnf-add'); if (!id || b.getAttribute('aria-busy') === 'true') return;
      b.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); b.classList.add('done'); note(b, true); })
        .catch(function () { note(b, false); })
        .then(function () { b.removeAttribute('aria-busy'); });
    });
  });
})();
